@file:OptIn(InternalResourceApi::class)

package quip.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/quip.composeapp.generated.resources/"

public val Res.string.spare_part_category_oil: StringResource by lazy {
      StringResource("string:spare_part_category_oil", "spare_part_category_oil", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18601, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20005, 39),
      ))
    }

public val Res.string.spare_part_category_other: StringResource by lazy {
      StringResource("string:spare_part_category_other", "spare_part_category_other", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18637, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20045, 41),
      ))
    }

public val Res.string.spare_part_category_tires: StringResource by lazy {
      StringResource("string:spare_part_category_tires", "spare_part_category_tires", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18679, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20087, 49),
      ))
    }

public val Res.string.spare_part_details: StringResource by lazy {
      StringResource("string:spare_part_details", "spare_part_details", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18761, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20181, 54),
      ))
    }

public val Res.string.spare_part_durability: StringResource by lazy {
      StringResource("string:spare_part_durability", "spare_part_durability", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18859, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20283, 45),
      ))
    }

public val Res.string.spare_part_durability_days: StringResource by lazy {
      StringResource("string:spare_part_durability_days", "spare_part_durability_days", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18812, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20236, 46),
      ))
    }

public val Res.string.spare_part_info: StringResource by lazy {
      StringResource("string:spare_part_info", "spare_part_info", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18905, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20329, 35),
      ))
    }

public val Res.string.spare_part_quantity: StringResource by lazy {
      StringResource("string:spare_part_quantity", "spare_part_quantity", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18941, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20365, 39),
      ))
    }

public val Res.string.spare_part_type: StringResource by lazy {
      StringResource("string:spare_part_type", "spare_part_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19769, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21317, 31),
      ))
    }

public val Res.string.spare_part_type_air_filter: StringResource by lazy {
      StringResource("string:spare_part_type_air_filter", "spare_part_type_air_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 18981, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20405, 54),
      ))
    }

public val Res.string.spare_part_type_all_brake_pads: StringResource by lazy {
      StringResource("string:spare_part_type_all_brake_pads", "spare_part_type_all_brake_pads", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19032, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20460, 78),
      ))
    }

public val Res.string.spare_part_type_battery_12v: StringResource by lazy {
      StringResource("string:spare_part_type_battery_12v", "spare_part_type_battery_12v", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19091, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20539, 51),
      ))
    }

public val Res.string.spare_part_type_brake_discs: StringResource by lazy {
      StringResource("string:spare_part_type_brake_discs", "spare_part_type_brake_discs", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19143, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20591, 55),
      ))
    }

public val Res.string.spare_part_type_brake_fluid: StringResource by lazy {
      StringResource("string:spare_part_type_brake_fluid", "spare_part_type_brake_fluid", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19195, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20647, 59),
      ))
    }

public val Res.string.spare_part_type_brake_pads_front: StringResource by lazy {
      StringResource("string:spare_part_type_brake_pads_front", "spare_part_type_brake_pads_front", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19247, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20707, 80),
      ))
    }

public val Res.string.spare_part_type_brake_pads_rear: StringResource by lazy {
      StringResource("string:spare_part_type_brake_pads_rear", "spare_part_type_brake_pads_rear", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19312, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20788, 75),
      ))
    }

public val Res.string.spare_part_type_cabin_filter: StringResource by lazy {
      StringResource("string:spare_part_type_cabin_filter", "spare_part_type_cabin_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19372, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20864, 64),
      ))
    }

public val Res.string.spare_part_type_engine_oil: StringResource by lazy {
      StringResource("string:spare_part_type_engine_oil", "spare_part_type_engine_oil", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19425, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20929, 54),
      ))
    }

public val Res.string.spare_part_type_fuel_filter: StringResource by lazy {
      StringResource("string:spare_part_type_fuel_filter", "spare_part_type_fuel_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19476, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20984, 63),
      ))
    }

public val Res.string.spare_part_type_label: StringResource by lazy {
      StringResource("string:spare_part_type_label", "spare_part_type_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19528, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21048, 53),
      ))
    }

public val Res.string.spare_part_type_oil_filter: StringResource by lazy {
      StringResource("string:spare_part_type_oil_filter", "spare_part_type_oil_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19578, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21102, 58),
      ))
    }

public val Res.string.spare_part_type_other: StringResource by lazy {
      StringResource("string:spare_part_type_other", "spare_part_type_other", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19629, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21161, 37),
      ))
    }

public val Res.string.spare_part_type_tire: StringResource by lazy {
      StringResource("string:spare_part_type_tire", "spare_part_type_tire", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19667, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21199, 44),
      ))
    }

public val Res.string.spare_part_type_transmission_oil: StringResource by lazy {
      StringResource("string:spare_part_type_transmission_oil", "spare_part_type_transmission_oil", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19704, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21244, 72),
      ))
    }

public val Res.string.spare_parts: StringResource by lazy {
      StringResource("string:spare_parts", "spare_parts", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19801, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21349, 31),
      ))
    }

public val Res.string.specifications: StringResource by lazy {
      StringResource("string:specifications", "specifications", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19837, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21381, 46),
      ))
    }

public val Res.string.splash_app_name: StringResource by lazy {
      StringResource("string:splash_app_name", "splash_app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19880, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21428, 31),
      ))
    }

public val Res.string.splash_subtitle: StringResource by lazy {
      StringResource("string:splash_subtitle", "splash_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19912, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21460, 47),
      ))
    }

public val Res.string.this_spare_part_type_requires_quantity: StringResource by lazy {
      StringResource("string:this_spare_part_type_requires_quantity", "this_spare_part_type_requires_quantity", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 19964, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21508, 118),
      ))
    }

public val Res.string.tire_pressure_bar: StringResource by lazy {
      StringResource("string:tire_pressure_bar", "tire_pressure_bar", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20083, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21627, 65),
      ))
    }

public val Res.string.tires_section: StringResource by lazy {
      StringResource("string:tires_section", "tires_section", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20137, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21693, 37),
      ))
    }

public val Res.string.total_cost: StringResource by lazy {
      StringResource("string:total_cost", "total_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20167, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21731, 34),
      ))
    }

public val Res.string.total_in_year: StringResource by lazy {
      StringResource("string:total_in_year", "total_in_year", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20202, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21766, 41),
      ))
    }

public val Res.string.update_vehicle: StringResource by lazy {
      StringResource("string:update_vehicle", "update_vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20244, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21808, 50),
      ))
    }

public val Res.string.user: StringResource by lazy {
      StringResource("string:user", "user", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20400, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21980, 24),
      ))
    }

public val Res.string.user_id_copied: StringResource by lazy {
      StringResource("string:user_id_copied", "user_id_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20287, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21859, 58),
      ))
    }

public val Res.string.user_id_label: StringResource by lazy {
      StringResource("string:user_id_label", "user_id_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20342, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 21918, 61),
      ))
    }

public val Res.string.vehicle: StringResource by lazy {
      StringResource("string:vehicle", "vehicle", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23426, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25170, 27),
      ))
    }

public val Res.string.vehicle_added_successfully: StringResource by lazy {
      StringResource("string:vehicle_added_successfully", "vehicle_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20421, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22005, 78),
      ))
    }

public val Res.string.vehicle_color_anthracite: StringResource by lazy {
      StringResource("string:vehicle_color_anthracite", "vehicle_color_anthracite", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20492, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22084, 44),
      ))
    }

public val Res.string.vehicle_color_beige: StringResource by lazy {
      StringResource("string:vehicle_color_beige", "vehicle_color_beige", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20541, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22129, 35),
      ))
    }

public val Res.string.vehicle_color_black: StringResource by lazy {
      StringResource("string:vehicle_color_black", "vehicle_color_black", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20634, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22226, 35),
      ))
    }

public val Res.string.vehicle_color_black_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_black_metallic", "vehicle_color_black_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20577, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22165, 60),
      ))
    }

public val Res.string.vehicle_color_blue: StringResource by lazy {
      StringResource("string:vehicle_color_blue", "vehicle_color_blue", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20906, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22510, 34),
      ))
    }

public val Res.string.vehicle_color_blue_dark: StringResource by lazy {
      StringResource("string:vehicle_color_blue_dark", "vehicle_color_blue_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20670, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22262, 47),
      ))
    }

public val Res.string.vehicle_color_blue_light: StringResource by lazy {
      StringResource("string:vehicle_color_blue_light", "vehicle_color_blue_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20714, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22310, 48),
      ))
    }

public val Res.string.vehicle_color_blue_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_blue_metallic", "vehicle_color_blue_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20763, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22359, 55),
      ))
    }

public val Res.string.vehicle_color_blue_navy: StringResource by lazy {
      StringResource("string:vehicle_color_blue_navy", "vehicle_color_blue_navy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20819, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22415, 47),
      ))
    }

public val Res.string.vehicle_color_blue_sky: StringResource by lazy {
      StringResource("string:vehicle_color_blue_sky", "vehicle_color_blue_sky", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20863, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22463, 46),
      ))
    }

public val Res.string.vehicle_color_bronze: StringResource by lazy {
      StringResource("string:vehicle_color_bronze", "vehicle_color_bronze", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20941, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22545, 36),
      ))
    }

public val Res.string.vehicle_color_brown: StringResource by lazy {
      StringResource("string:vehicle_color_brown", "vehicle_color_brown", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21077, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22689, 39),
      ))
    }

public val Res.string.vehicle_color_brown_dark: StringResource by lazy {
      StringResource("string:vehicle_color_brown_dark", "vehicle_color_brown_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 20978, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22582, 52),
      ))
    }

public val Res.string.vehicle_color_brown_light: StringResource by lazy {
      StringResource("string:vehicle_color_brown_light", "vehicle_color_brown_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21027, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22635, 53),
      ))
    }

public val Res.string.vehicle_color_burgundy: StringResource by lazy {
      StringResource("string:vehicle_color_burgundy", "vehicle_color_burgundy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21113, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22729, 42),
      ))
    }

public val Res.string.vehicle_color_champagne: StringResource by lazy {
      StringResource("string:vehicle_color_champagne", "vehicle_color_champagne", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21156, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22772, 43),
      ))
    }

public val Res.string.vehicle_color_cherry: StringResource by lazy {
      StringResource("string:vehicle_color_cherry", "vehicle_color_cherry", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21200, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22816, 36),
      ))
    }

public val Res.string.vehicle_color_copper: StringResource by lazy {
      StringResource("string:vehicle_color_copper", "vehicle_color_copper", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21237, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22853, 36),
      ))
    }

public val Res.string.vehicle_color_cyan: StringResource by lazy {
      StringResource("string:vehicle_color_cyan", "vehicle_color_cyan", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21274, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22890, 34),
      ))
    }

public val Res.string.vehicle_color_gold: StringResource by lazy {
      StringResource("string:vehicle_color_gold", "vehicle_color_gold", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21365, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22985, 34),
      ))
    }

public val Res.string.vehicle_color_gold_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_gold_metallic", "vehicle_color_gold_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21309, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22925, 59),
      ))
    }

public val Res.string.vehicle_color_graphite: StringResource by lazy {
      StringResource("string:vehicle_color_graphite", "vehicle_color_graphite", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21400, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23020, 42),
      ))
    }

public val Res.string.vehicle_color_green: StringResource by lazy {
      StringResource("string:vehicle_color_green", "vehicle_color_green", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21599, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23223, 35),
      ))
    }

public val Res.string.vehicle_color_green_dark: StringResource by lazy {
      StringResource("string:vehicle_color_green_dark", "vehicle_color_green_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21443, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23063, 48),
      ))
    }

public val Res.string.vehicle_color_green_light: StringResource by lazy {
      StringResource("string:vehicle_color_green_light", "vehicle_color_green_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21492, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23112, 49),
      ))
    }

public val Res.string.vehicle_color_green_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_green_metallic", "vehicle_color_green_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21542, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23162, 60),
      ))
    }

public val Res.string.vehicle_color_grey: StringResource by lazy {
      StringResource("string:vehicle_color_grey", "vehicle_color_grey", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21679, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23307, 34),
      ))
    }

public val Res.string.vehicle_color_grey_dark: StringResource by lazy {
      StringResource("string:vehicle_color_grey_dark", "vehicle_color_grey_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21635, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23259, 47),
      ))
    }

public val Res.string.vehicle_color_ivory: StringResource by lazy {
      StringResource("string:vehicle_color_ivory", "vehicle_color_ivory", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21714, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23342, 35),
      ))
    }

public val Res.string.vehicle_color_khaki: StringResource by lazy {
      StringResource("string:vehicle_color_khaki", "vehicle_color_khaki", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21750, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23378, 35),
      ))
    }

public val Res.string.vehicle_color_lavender: StringResource by lazy {
      StringResource("string:vehicle_color_lavender", "vehicle_color_lavender", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21786, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23414, 42),
      ))
    }

public val Res.string.vehicle_color_magenta: StringResource by lazy {
      StringResource("string:vehicle_color_magenta", "vehicle_color_magenta", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21829, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23457, 41),
      ))
    }

public val Res.string.vehicle_color_maroon: StringResource by lazy {
      StringResource("string:vehicle_color_maroon", "vehicle_color_maroon", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21871, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23499, 40),
      ))
    }

public val Res.string.vehicle_color_olive: StringResource by lazy {
      StringResource("string:vehicle_color_olive", "vehicle_color_olive", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21908, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23540, 35),
      ))
    }

public val Res.string.vehicle_color_orange: StringResource by lazy {
      StringResource("string:vehicle_color_orange", "vehicle_color_orange", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22052, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23692, 40),
      ))
    }

public val Res.string.vehicle_color_orange_dark: StringResource by lazy {
      StringResource("string:vehicle_color_orange_dark", "vehicle_color_orange_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21944, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23576, 53),
      ))
    }

public val Res.string.vehicle_color_orange_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_orange_metallic", "vehicle_color_orange_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 21994, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23630, 61),
      ))
    }

public val Res.string.vehicle_color_pink: StringResource by lazy {
      StringResource("string:vehicle_color_pink", "vehicle_color_pink", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22138, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23782, 34),
      ))
    }

public val Res.string.vehicle_color_pink_light: StringResource by lazy {
      StringResource("string:vehicle_color_pink_light", "vehicle_color_pink_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22089, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23733, 48),
      ))
    }

public val Res.string.vehicle_color_plum: StringResource by lazy {
      StringResource("string:vehicle_color_plum", "vehicle_color_plum", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22173, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23817, 38),
      ))
    }

public val Res.string.vehicle_color_purple: StringResource by lazy {
      StringResource("string:vehicle_color_purple", "vehicle_color_purple", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22258, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23910, 36),
      ))
    }

public val Res.string.vehicle_color_purple_dark: StringResource by lazy {
      StringResource("string:vehicle_color_purple_dark", "vehicle_color_purple_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22208, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23856, 53),
      ))
    }

public val Res.string.vehicle_color_red: StringResource by lazy {
      StringResource("string:vehicle_color_red", "vehicle_color_red", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22389, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24049, 33),
      ))
    }

public val Res.string.vehicle_color_red_dark: StringResource by lazy {
      StringResource("string:vehicle_color_red_dark", "vehicle_color_red_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22295, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23947, 46),
      ))
    }

public val Res.string.vehicle_color_red_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_red_metallic", "vehicle_color_red_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22338, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23994, 54),
      ))
    }

public val Res.string.vehicle_color_sand: StringResource by lazy {
      StringResource("string:vehicle_color_sand", "vehicle_color_sand", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22419, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24083, 34),
      ))
    }

public val Res.string.vehicle_color_select: StringResource by lazy {
      StringResource("string:vehicle_color_select", "vehicle_color_select", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22454, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24118, 52),
      ))
    }

public val Res.string.vehicle_color_silver: StringResource by lazy {
      StringResource("string:vehicle_color_silver", "vehicle_color_silver", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22557, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24233, 36),
      ))
    }

public val Res.string.vehicle_color_silver_metallic: StringResource by lazy {
      StringResource("string:vehicle_color_silver_metallic", "vehicle_color_silver_metallic", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22499, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24171, 61),
      ))
    }

public val Res.string.vehicle_color_teal: StringResource by lazy {
      StringResource("string:vehicle_color_teal", "vehicle_color_teal", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22594, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24270, 46),
      ))
    }

public val Res.string.vehicle_color_turquoise: StringResource by lazy {
      StringResource("string:vehicle_color_turquoise", "vehicle_color_turquoise", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22629, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24317, 43),
      ))
    }

public val Res.string.vehicle_color_violet: StringResource by lazy {
      StringResource("string:vehicle_color_violet", "vehicle_color_violet", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22673, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24361, 40),
      ))
    }

public val Res.string.vehicle_color_white: StringResource by lazy {
      StringResource("string:vehicle_color_white", "vehicle_color_white", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22760, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24452, 35),
      ))
    }

public val Res.string.vehicle_color_white_pearl: StringResource by lazy {
      StringResource("string:vehicle_color_white_pearl", "vehicle_color_white_pearl", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22710, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24402, 49),
      ))
    }

public val Res.string.vehicle_color_yellow: StringResource by lazy {
      StringResource("string:vehicle_color_yellow", "vehicle_color_yellow", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22852, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24548, 40),
      ))
    }

public val Res.string.vehicle_color_yellow_bright: StringResource by lazy {
      StringResource("string:vehicle_color_yellow_bright", "vehicle_color_yellow_bright", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22796, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24488, 59),
      ))
    }

public val Res.string.vehicle_detail_spare_parts: StringResource by lazy {
      StringResource("string:vehicle_detail_spare_parts", "vehicle_detail_spare_parts", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22889, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24589, 46),
      ))
    }

public val Res.string.vehicle_details: StringResource by lazy {
      StringResource("string:vehicle_details", "vehicle_details", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22940, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24636, 55),
      ))
    }

public val Res.string.vehicle_duplicate_vin: StringResource by lazy {
      StringResource("string:vehicle_duplicate_vin", "vehicle_duplicate_vin", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 22984, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24692, 77),
      ))
    }

public val Res.string.vehicle_list: StringResource by lazy {
      StringResource("string:vehicle_list", "vehicle_list", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23070, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24770, 48),
      ))
    }

public val Res.string.vehicle_type: StringResource by lazy {
      StringResource("string:vehicle_type", "vehicle_type", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 23312, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25040, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("spare_part_category_oil", Res.string.spare_part_category_oil)
  map.put("spare_part_category_other", Res.string.spare_part_category_other)
  map.put("spare_part_category_tires", Res.string.spare_part_category_tires)
  map.put("spare_part_details", Res.string.spare_part_details)
  map.put("spare_part_durability", Res.string.spare_part_durability)
  map.put("spare_part_durability_days", Res.string.spare_part_durability_days)
  map.put("spare_part_info", Res.string.spare_part_info)
  map.put("spare_part_quantity", Res.string.spare_part_quantity)
  map.put("spare_part_type", Res.string.spare_part_type)
  map.put("spare_part_type_air_filter", Res.string.spare_part_type_air_filter)
  map.put("spare_part_type_all_brake_pads", Res.string.spare_part_type_all_brake_pads)
  map.put("spare_part_type_battery_12v", Res.string.spare_part_type_battery_12v)
  map.put("spare_part_type_brake_discs", Res.string.spare_part_type_brake_discs)
  map.put("spare_part_type_brake_fluid", Res.string.spare_part_type_brake_fluid)
  map.put("spare_part_type_brake_pads_front", Res.string.spare_part_type_brake_pads_front)
  map.put("spare_part_type_brake_pads_rear", Res.string.spare_part_type_brake_pads_rear)
  map.put("spare_part_type_cabin_filter", Res.string.spare_part_type_cabin_filter)
  map.put("spare_part_type_engine_oil", Res.string.spare_part_type_engine_oil)
  map.put("spare_part_type_fuel_filter", Res.string.spare_part_type_fuel_filter)
  map.put("spare_part_type_label", Res.string.spare_part_type_label)
  map.put("spare_part_type_oil_filter", Res.string.spare_part_type_oil_filter)
  map.put("spare_part_type_other", Res.string.spare_part_type_other)
  map.put("spare_part_type_tire", Res.string.spare_part_type_tire)
  map.put("spare_part_type_transmission_oil", Res.string.spare_part_type_transmission_oil)
  map.put("spare_parts", Res.string.spare_parts)
  map.put("specifications", Res.string.specifications)
  map.put("splash_app_name", Res.string.splash_app_name)
  map.put("splash_subtitle", Res.string.splash_subtitle)
  map.put("this_spare_part_type_requires_quantity", Res.string.this_spare_part_type_requires_quantity)
  map.put("tire_pressure_bar", Res.string.tire_pressure_bar)
  map.put("tires_section", Res.string.tires_section)
  map.put("total_cost", Res.string.total_cost)
  map.put("total_in_year", Res.string.total_in_year)
  map.put("update_vehicle", Res.string.update_vehicle)
  map.put("user", Res.string.user)
  map.put("user_id_copied", Res.string.user_id_copied)
  map.put("user_id_label", Res.string.user_id_label)
  map.put("vehicle", Res.string.vehicle)
  map.put("vehicle_added_successfully", Res.string.vehicle_added_successfully)
  map.put("vehicle_color_anthracite", Res.string.vehicle_color_anthracite)
  map.put("vehicle_color_beige", Res.string.vehicle_color_beige)
  map.put("vehicle_color_black", Res.string.vehicle_color_black)
  map.put("vehicle_color_black_metallic", Res.string.vehicle_color_black_metallic)
  map.put("vehicle_color_blue", Res.string.vehicle_color_blue)
  map.put("vehicle_color_blue_dark", Res.string.vehicle_color_blue_dark)
  map.put("vehicle_color_blue_light", Res.string.vehicle_color_blue_light)
  map.put("vehicle_color_blue_metallic", Res.string.vehicle_color_blue_metallic)
  map.put("vehicle_color_blue_navy", Res.string.vehicle_color_blue_navy)
  map.put("vehicle_color_blue_sky", Res.string.vehicle_color_blue_sky)
  map.put("vehicle_color_bronze", Res.string.vehicle_color_bronze)
  map.put("vehicle_color_brown", Res.string.vehicle_color_brown)
  map.put("vehicle_color_brown_dark", Res.string.vehicle_color_brown_dark)
  map.put("vehicle_color_brown_light", Res.string.vehicle_color_brown_light)
  map.put("vehicle_color_burgundy", Res.string.vehicle_color_burgundy)
  map.put("vehicle_color_champagne", Res.string.vehicle_color_champagne)
  map.put("vehicle_color_cherry", Res.string.vehicle_color_cherry)
  map.put("vehicle_color_copper", Res.string.vehicle_color_copper)
  map.put("vehicle_color_cyan", Res.string.vehicle_color_cyan)
  map.put("vehicle_color_gold", Res.string.vehicle_color_gold)
  map.put("vehicle_color_gold_metallic", Res.string.vehicle_color_gold_metallic)
  map.put("vehicle_color_graphite", Res.string.vehicle_color_graphite)
  map.put("vehicle_color_green", Res.string.vehicle_color_green)
  map.put("vehicle_color_green_dark", Res.string.vehicle_color_green_dark)
  map.put("vehicle_color_green_light", Res.string.vehicle_color_green_light)
  map.put("vehicle_color_green_metallic", Res.string.vehicle_color_green_metallic)
  map.put("vehicle_color_grey", Res.string.vehicle_color_grey)
  map.put("vehicle_color_grey_dark", Res.string.vehicle_color_grey_dark)
  map.put("vehicle_color_ivory", Res.string.vehicle_color_ivory)
  map.put("vehicle_color_khaki", Res.string.vehicle_color_khaki)
  map.put("vehicle_color_lavender", Res.string.vehicle_color_lavender)
  map.put("vehicle_color_magenta", Res.string.vehicle_color_magenta)
  map.put("vehicle_color_maroon", Res.string.vehicle_color_maroon)
  map.put("vehicle_color_olive", Res.string.vehicle_color_olive)
  map.put("vehicle_color_orange", Res.string.vehicle_color_orange)
  map.put("vehicle_color_orange_dark", Res.string.vehicle_color_orange_dark)
  map.put("vehicle_color_orange_metallic", Res.string.vehicle_color_orange_metallic)
  map.put("vehicle_color_pink", Res.string.vehicle_color_pink)
  map.put("vehicle_color_pink_light", Res.string.vehicle_color_pink_light)
  map.put("vehicle_color_plum", Res.string.vehicle_color_plum)
  map.put("vehicle_color_purple", Res.string.vehicle_color_purple)
  map.put("vehicle_color_purple_dark", Res.string.vehicle_color_purple_dark)
  map.put("vehicle_color_red", Res.string.vehicle_color_red)
  map.put("vehicle_color_red_dark", Res.string.vehicle_color_red_dark)
  map.put("vehicle_color_red_metallic", Res.string.vehicle_color_red_metallic)
  map.put("vehicle_color_sand", Res.string.vehicle_color_sand)
  map.put("vehicle_color_select", Res.string.vehicle_color_select)
  map.put("vehicle_color_silver", Res.string.vehicle_color_silver)
  map.put("vehicle_color_silver_metallic", Res.string.vehicle_color_silver_metallic)
  map.put("vehicle_color_teal", Res.string.vehicle_color_teal)
  map.put("vehicle_color_turquoise", Res.string.vehicle_color_turquoise)
  map.put("vehicle_color_violet", Res.string.vehicle_color_violet)
  map.put("vehicle_color_white", Res.string.vehicle_color_white)
  map.put("vehicle_color_white_pearl", Res.string.vehicle_color_white_pearl)
  map.put("vehicle_color_yellow", Res.string.vehicle_color_yellow)
  map.put("vehicle_color_yellow_bright", Res.string.vehicle_color_yellow_bright)
  map.put("vehicle_detail_spare_parts", Res.string.vehicle_detail_spare_parts)
  map.put("vehicle_details", Res.string.vehicle_details)
  map.put("vehicle_duplicate_vin", Res.string.vehicle_duplicate_vin)
  map.put("vehicle_list", Res.string.vehicle_list)
  map.put("vehicle_type", Res.string.vehicle_type)
}
